// Resolve.
export const RESOLVE_APP = "RESOLVE_APP";
export const RESOLVE_APP_SUCCESS = "RESOLVE_APP_SUCCESS";
export const RESOLVE_APP_ERROR = "RESOLVE_APP_ERROR";

// Set current href/pathname, needed for SSR
export const SET_HOST_STATE = "SET_HOST_STATE";
